import * as z from "zod";

export const ProjectSchema = z.string();
export const projectsSchema = z.array(ProjectSchema);

export type Project = z.infer<typeof ProjectSchema>;
export type Projects = z.infer<typeof projectsSchema>;
